import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const DeleteCajaModal = ({ open, onClose, onConfirm, cajaNombre, loading }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" sx={{ 
          fontFamily: "Bricolage Grotesque", 
          color: "#d32f2f",
          fontWeight: 600 
        }}>
          Confirmar eliminación
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ 
          color: "#333",
          fontSize: "16px",
          lineHeight: 1.6 
        }}>
          ¿Estás seguro de que deseas eliminar la caja <strong>"{cajaNombre}"</strong>?
        </Typography>
        <Typography sx={{ 
          color: "#d32f2f",
          fontSize: "14px",
          mt: 2,
          fontWeight: 500 
        }}>
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          sx={{
            border: "1px solid #ccc",
            color: "#666",
            '&:hover': {
              backgroundColor: "#f5f5f5"
            }
          }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          sx={{
            backgroundColor: "#d32f2f",
            '&:hover': {
              backgroundColor: "#c62828"
            }
          }}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCajaModal;